import React from 'react';
import styled from 'styled-components';
import { TertiaryTitle } from '../../../../Typography/Title.styles';
import RichTextViewer from '../../RichTextViewer';
import ViewerErrorBoundary from './ViewerErrorBoundary';
const ConclusionTitleContainer = styled.div `
    margin-bottom: 1rem;
`;
const ViewerConclusion = ({ conclusion }) => {
    if (conclusion) {
        return (React.createElement(ViewerErrorBoundary, null,
            React.createElement(ConclusionTitleContainer, null,
                React.createElement(TertiaryTitle, null, "Conclusion")),
            React.createElement(RichTextViewer, { componentValues: { body: conclusion } })));
    }
    return null;
};
export default ViewerConclusion;
//# sourceMappingURL=index.js.map